import React from 'react'

import { ProductClassStatus } from 'core/domain/benefit/productClassStatus'

import { Menu, MenuItem } from 'common/components'

const menu = (
  status,
  productClassId,
  handleEditModal: { (productClassId: string): void; (arg0: string): void },
  handleDeleteModal: { (productClassId: string): void; (arg0: string): void },
): JSX.Element => {
  return (
    <Menu>
      {status !== ProductClassStatus.Archived && (
        <MenuItem key={1} onClick={() => handleEditModal(productClassId)}>
          Edit
        </MenuItem>
      )}
      <MenuItem key={2} onClick={() => handleDeleteModal(productClassId)}>
        Delete
      </MenuItem>
      {status === ProductClassStatus.Active && (
        <MenuItem key={3} onClick={() => console.log('Archive')}>
          Archive
        </MenuItem>
      )}
    </Menu>
  )
}

export default menu
